import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useService } from 'shared/providers';
import { GetUsersResponse } from 'shared/services';
import { Brands } from 'shared/types';

export function useUsers(brand: Brands, loggedInUserId: string) {
  const { userService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const { data, isLoading, isFetching } = useQuery<GetUsersResponse, Error>(
    ['users', brand],
    () => userService.getUsers(brand, loggedInUserId),

    {
      onError: error => {
        enqueueSnackbar(error.message, { variant: 'error' });
      },
      retry: false,
    }
  );
  return {
    users: data?.brandUsers || [],
    dropdownOptions: data?.dropdownOptions || [],
    isLoading,
    isFetching,
  } as const;
}
